<app-pagination [paginationInfo]="paginationInfo"></app-pagination>
<mat-list>
    <app-message-item [message]="message" *ngFor="let message of messages |async"></app-message-item>
</mat-list>